import { createSlice } from '@reduxjs/toolkit';
import { OrganisationRoleType } from 'src/graphql';

export type UserInitialState = {
  organisationRoles?: OrganisationRoleType[];
};

const initialState: UserInitialState = {
  organisationRoles: [],
};

export const userSlice = createSlice({
  name: 'user',
  initialState,

  reducers: {
    organisationRolesUpdated: (
      state,
      action: { payload: OrganisationRoleType[] },
    ) => {
      if (!action.payload || !action.payload.length) {
        return state;
      }

      state.organisationRoles = action.payload;
    },
  },

  selectors: {
    getOrganisationRoles: (state: UserInitialState) => state.organisationRoles,
  },
});

export const { organisationRolesUpdated } = userSlice.actions;
export const { getOrganisationRoles } = userSlice.selectors;

export const userReducer = userSlice.reducer;
